import CircleIcon from '@mui/icons-material/Circle';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import { SxProps } from '@mui/material';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import React from 'react';

type DotStepperProps = {
  sx?: SxProps;
  steps: number; // Total number of steps
  activeStep: number; // Current active step
  onStepChange: (step: number) => void; // Callback to handle step changes
  disableForward?: boolean; // Disables forward navigation
  disableBackward?: boolean; // Disables backward navigation
};

const DotStepper: React.FC<DotStepperProps> = ({
  sx,
  steps,
  activeStep,
  onStepChange,
  disableForward = false,
  disableBackward = false,
}) => {
  const isStepDisabled = (index: number) => {
    if (disableBackward && index < activeStep) return true;
    if (disableForward && index > activeStep) return true;
    return false;
  };

  return (
    <Box
      sx={{
        py: 2,
        gap: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...sx,
      }}>
      {Array.from({ length: steps }, (_, index) => (
        <IconButton
          key={index}
          onClick={() => !isStepDisabled(index) && onStepChange(index)}
          disabled={isStepDisabled(index)}
          sx={{
            color: activeStep === index ? 'primary.main' : 'grey.500',
            padding: 0,
          }}>
          {activeStep === index ? (
            <CircleIcon sx={{ fontSize: 14 }} />
          ) : (
            <CircleOutlinedIcon sx={{ fontSize: 14 }} />
          )}
        </IconButton>
      ))}
    </Box>
  );
};

export default DotStepper;
